import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
  ACQUISITION_LIST, ACQUISITION_DETAIL, ACQUISITION_ADD,
  ACQUISITION_FILTER_DETAIL_TYPE, ACQUISITION_FILTER_DETAIL_PARENT
} from '../../actions';
import {
  AcquisitionListSuccess, AcquisitionListError,
  AcquisitionDetailSuccess, AcquisitionDetailError,
  AcquisitionAddSuccess, AcquisitionAddError,
  AcquisitionFilterDetailTypeSuccess,
  AcquisitionFilterDetailParentSuccess
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition/acquisition/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition/acquisition/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition/acquisition/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onFilterDetailTypeAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/acquisition/acquisition_detail_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterDetailParentAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/acquisition/acquisition_detail_parent', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(AcquisitionListSuccess(response.data)); }
  catch (error) { yield put(AcquisitionListError(error)); }
}
function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(AcquisitionDetailSuccess(response.data.data)); }
  catch (error) { yield put(AcquisitionDetailError(error)); }
}
function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Éxito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(AcquisitionAddSuccess(response.data));
  } catch (error) { yield put(AcquisitionAddError(error)); }
}
function* onFilterDetailType() {
  try { const response = yield call(onFilterDetailTypeAsync); yield put(AcquisitionFilterDetailTypeSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}
function* onFilterDetailParent() {
  try { const response = yield call(onFilterDetailParentAsync); yield put(AcquisitionFilterDetailParentSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(ACQUISITION_LIST, onList); }
export function* watchDetail() { yield takeEvery(ACQUISITION_DETAIL, onDetail); }
export function* watchAdd() { yield takeEvery(ACQUISITION_ADD, onAdd); }
export function* watchFilterDetailType() { yield takeEvery(ACQUISITION_FILTER_DETAIL_TYPE, onFilterDetailType); }
export function* watchFilterDetailParent() { yield takeEvery(ACQUISITION_FILTER_DETAIL_PARENT, onFilterDetailParent); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchDetail), fork(watchAdd), fork(watchFilterDetailType), fork(watchFilterDetailParent)]);
}
